// components/SponsorPanel.js
// Yuan Wang
// Copyright AMRC 2020

import React, { useState, useEffect } from 'react';
import Image from 'material-ui-image';
import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import Fade from 'react-reveal/Fade';
export const LOGOS = [
  { 
    img: "https://www.okaloosaisland.com/wp-content/uploads/2016/07/gulfarium-business-listing-okaloosa-island.jpg",
    href: "http://www.gulfarium.com/"
  },
  { 
    img: "https://greatsouthernrestaurants.com/wp-content/themes/gsrestaurants/img/gsr-logo.png",
    href: "https://greatsouthernrestaurants.com/"
  },
  { 
    img: "https://public.myfwc.com/HGM/NWT/images/logo-fwc-gl.png",
    href: "https://myfwc.com/"
  },
  { 
    img: "https://ded8b07dd9e637888fc2-e87978aaae5cf97349d88697fd53e4c9.ssl.cf1.rackcdn.com/ab05879d-ade1-41b6-b7d3-e9e299a42ee6.jpg",
    href: "https://www.coastwatchalliance.org/"
  },
]

const useStyles = makeStyles((theme) => 
  createStyles({
    whitenImage: {
      maxHeight: 100,
      maxWidth: 200,
      minWidth: 200,
      minHeight: 100,
      objectFit: 'contain',
      
      // filter: "invert(100%) sepia(0%) saturate(0%) hue-rotate(24deg) brightness(10002%) contrast(10001%)"
    },
    logoContainer: {
      // maxHeight: 80,
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(0),
      display: 'flex',
    }, 
    grid: {
      // backgroundColor: 'red'
    }
  })
)

const FRAME_TIME = 1000

export default function Logos() {
  const classes = useStyles()
  // const [ activeIndex, setActiveIndex ] = useState(0)

  // const nextActiveIndex = (index) => {
  //   const nextIndex = (index + 1) % 3
  //   setActiveIndex(nextIndex)
  //   setTimeout(() => nextActiveIndex(nextIndex), FRAME_TIME)
  // }

  // useEffect(() => {
  //   const timeout = setTimeout(() => nextActiveIndex(0), FRAME_TIME);
  //   // nextActiveIndex(0)
  //   // Specify how to clean up after this effect:
  //   return function cleanup() {
  //     clearTimeout(timeout)
  //   };
  // }, []);

  return (
    <Grid container className={classes.grid}>
      
      { LOGOS.map(({ img, href }, index) => (
        
        <Grid 
          item 
          key={index} 
          xs={6} 
          sm={3} 
          md={3} 
          className={classes.logoContainer}>
          <Fade delay={4000} duration={2000}>
          <a href={href}>
          <img
            key={index}
            className={classes.whitenImage}
            imageStyle={{ objectFit: 'contain'}}
            alt="third party vendor logo"
            src={img}
            aspectRatio={3}
          />
          </a>
          </Fade>
        </Grid>
      ))}
      
      {/* <Hidden only={["xs"]}>
        { LOGOS.map((logo, index) => (
          <Grid 
            item 
            key={index} 
            xs={6} 
            sm={3} 
            md={2} 
            className={classes.logoContainer}>
            <Image
              key={index}
              className={classes.whitenImage}
              imageStyle={{ objectFit: 'contain'}}
              alt="third party vendor logo"
              src={logo}
              aspectRatio={3}
            />
          </Grid>
        ))}
      </Hidden> */}
    </Grid>
  )
}